<template>
  <footer class="footer">
    <b-row>
      <b-col>
        <router-link class="p-2" to="/imprint" place="terms">{{ $t('message.footer.imprint') }}</router-link>
        <router-link class="p-2" to="/terms" place="terms">{{ $t('message.footer.terms') }}</router-link>
        <router-link class="p-2" to="/policies" place="privacyPolicies">{{ $t('message.footer.privacyPolicies') }}</router-link>
        <router-link class="p-2" to="/info" place="terms">{{ $t('message.footer.info') }}</router-link>
      </b-col>
      <b-col class="text-right">
        <span class="p-2">{{ $t('message.footer.copyright') }}</span>
      </b-col>
    </b-row>
  </footer>
</template>

<script>
  export default {
    name: 'TermsFooter'
  }
</script>

<style scoped>
  .footer {
    background-color: #ffffff;
    border-top: 1px solid rgba(120, 130, 140, 0.13);
    color: #67757c;
    padding: 0.8rem 0.8rem;
    width: 100%;
    height: 100%;
  }

  a {
    color: #67757c;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/TermsFooter.vue